import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, FsCatalog, TextInput } from '../../types'
import { CmsConverterService, defaultFSCatalog, defaultTextInput } from '../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class HandBookFirstLevelConverter extends CmsConverterService<HandBookFirstLevelData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      content: formData?.st_content ?? defaultFSCatalog,
      headline: formData?.st_headline ?? defaultTextInput
    }
  }
}

export const HANDBOOK_FIRST_LEVEL_CONVERTER_TOKEN =
  new InjectionToken<Converter<CmsComponent, HandBookFirstLevelData>>('HandBookFirstLevelConverter')

export interface HandBookFirstLevelData extends ConvertedComponentData {
  headline: TextInput;
  content: FsCatalog;
}
